import {FC} from "react";
import {UserLocationTabContent} from "./content";
import {useOutletContext} from "react-router-dom";
import {UserPageOutletContext} from "../index";

export const UserLocationTab: FC = () => {
    const [user] = useOutletContext<UserPageOutletContext>();
    return <UserLocationTabContent user={user}/>
};
